import { ADVANCE_SEARCH_DATA_REQUEST } from "@src/middleware/actions/actionTypes";
import { fetchASDOptionsLoading, fetchASDOptionsSuccess } from "@src/middleware/actions/AdvanceSearch/ASDActions";
import { getAdvanceSearchData } from "@src/middleware/services/AdvanceSearch/AdvanceSearch.service";
import { call, put, takeLatest } from "redux-saga/effects";


export function* fetchAdvanceSearchData(action: any) {
  try {
    yield put(fetchASDOptionsLoading(true));
    const response = yield call(getAdvanceSearchData, action.payload);
    if (response) {
      yield put(fetchASDOptionsSuccess(response));
    }
  } catch (error) {
  } finally {
    yield put(fetchASDOptionsLoading(false));
  }
}

export function* advanceSearchSaga() {
  yield takeLatest(ADVANCE_SEARCH_DATA_REQUEST, fetchAdvanceSearchData);
}